module.exports = {
  "ent_o_meta_description": "Keeta for Business streamlines your corporate meal management with smart allowance and reimbursement tools. Our intuitive platform helps you reduce administrative work while keeping your employees happy. From customizable rules to seamless workflows, we make corporate dining management both efficient and enjoyable.",
  "ent_o_meta_keywords": "Keeta for Business, corporate meal management, dining allowance, employee benefits, expense management, meal program, corporate catering, automated reimbursement, company meals, staff dining",
  "ent_o_page_title": "Keeta for Business - Smart Corporate Meal Management Made Simple",
  "ent_o_nav_logo": "Keeta Business",
  "ent_o_nav_contact": "Contact Sales",
  "ent_o_nav_login": "Login",
  "ent_o_hero_title": "Simplifies Employee Benefits Management",
  "ent_o_hero_subtitle": "Keeta Business enables companies to efficiently manage employee allowances and reimbursements.",
  "ent_o_hero_cta": "Get Started",
  "ent_o_features_title": "Key Features",
  "ent_o_features_cards_0_title": "Flexible Management",
  "ent_o_features_cards_0_desc": "Customize allowance rules and policies based on your needs",
  "ent_o_features_cards_1_title": "Streamlined Process",
  "ent_o_features_cards_1_desc": "Simplify administrative workflows and improve efficiency",
  "ent_o_features_cards_2_title": "Employee Satisfaction",
  "ent_o_features_cards_2_desc": "Provide diverse dining options and enhance employee experience",
  "ent_o_features_cards_3_title": "User Friendly",
  "ent_o_features_cards_3_desc": "Easy to use interface for both administrators and employees",
  "ent_o_benefits_title": "The Keeta Advantage",
  "ent_o_benefits_items_0_title": "Strategic Allowance Management",
  "ent_o_benefits_items_0_desc": "Optimize budgets and track expenditure with precision tools designed for enterprise needs.",
  "ent_o_benefits_items_1_title": "Extensive Restaurant Network",
  "ent_o_benefits_items_1_desc": "Access a curated ecosystem of dining partners, offering diverse options to satisfy every preference.",
  "ent_o_benefits_items_2_title": "Intelligent Process Automation",
  "ent_o_benefits_items_2_desc": "Leverage advanced automation to eliminate manual tasks and enhance operational efficiency.",
  "ent_o_benefits_items_3_title": "Dynamic Policy Engine",
  "ent_o_benefits_items_3_desc": "Configure and adapt meal policies with enterprise-grade flexibility and control.",
  "ent_o_benefits_items_4_title": "Intuitive Enterprise Platform",
  "ent_o_benefits_items_4_desc": "Experience a sophisticated yet user-friendly interface designed for corporate efficiency.",
  "ent_o_cta_title": "Get Started Today",
  "ent_o_contact_title": "Contact Sales",
  "ent_o_contact_subtitle": "Interested in learning more about Keeta for Business? Let\'s talk.",
  "ent_o_contact_form_placeholder": "Please enter",
  "ent_o_contact_form_validation_required": "Please fill in this field",
  "ent_o_contact_form_validation_invalidEmail": "Please enter a valid email address",
  "ent_o_contact_form_validation_fillIn": "Please fill in",
  "ent_o_contact_form_validation_incorrectInfo": "Information is incorrect, please check",
  "ent_o_contact_form_firstName": "First Name",
  "ent_o_contact_form_lastName": "Last Name",
  "ent_o_contact_form_email": "Business Email",
  "ent_o_contact_form_phone_label": "Phone Number",
  "ent_o_contact_form_phone_placeholder": "phone number (e.g. +852 9123 4567)",
  "ent_o_contact_form_phone_invalidPhone": "Invalid phone number",
  "ent_o_contact_form_company": "Company Name",
  "ent_o_contact_form_size_label": "Company Size",
  "ent_o_contact_form_size_placeholder": "Please Select",
  "ent_o_contact_form_size_options_1": "1 - 50 people",
  "ent_o_contact_form_size_options_2": "51 - 200 people",
  "ent_o_contact_form_size_options_3": "201 - 500 people",
  "ent_o_contact_form_size_options_4": "501 - 1000 people",
  "ent_o_contact_form_size_options_5": "1000 people or more",
  "ent_o_contact_form_usage_label": "Usage Frequency",
  "ent_o_contact_form_usage_placeholder": "Please Select",
  "ent_o_contact_form_usage_options_1": "Regular meal provision (e.g., office meals, overtime meals)",
  "ent_o_contact_form_usage_options_2": "Regular allowance provision (e.g., monthly meal allowances)",
  "ent_o_contact_form_usage_options_3": "Occasional meal provision (e.g., events, meetings)",
  "ent_o_contact_form_submit": "Submit",
  "ent_o_contact_form_submitSuccess": "We have received your submission successfully. Our sales representative will contact you shortly.",
  "ent_o_footer_contact_corporate": "Corporate Services:",
}